export default "__VITE_ASSET__6c8f7585__"